import { CpmButton, CpmModal, CpmModalFooter } from '../../../../components/design-system';

interface DiscardEditsWarnDialogProps {
    open: boolean;
    dirtyCount: number;
    onKeep: () => void;
    onDiscard: () => void;
}

export default function DiscardEditsWarnDialog({
    open,
    dirtyCount,
    onKeep,
    onDiscard,
}: DiscardEditsWarnDialogProps) {
    const discardLabel = dirtyCount === 1 ? 'Discard 1 edit' : `Discard ${dirtyCount} edits`;

    return (
        <CpmModal open={open} onClose={onKeep} maxWidth={520} zIndex={78}>
            <div className="flex items-start gap-[14px]" style={{ padding: '22px 24px 18px' }}>
                <span className="shrink-0 inline-flex items-center justify-center w-[38px] h-[38px] rounded-[10px] bg-[var(--cpm-warning-bg)] text-[var(--cpm-warning-text)]">
                    <svg
                        width="19"
                        height="19"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                    >
                        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                        <path d="M12 9v4M12 17h.01" strokeLinecap="round" />
                    </svg>
                </span>
                <div className="flex-1 min-w-0 flex flex-col" style={{ gap: 6 }}>
                    <h2 className="m-0 !text-[19px] !font-extrabold !tracking-[-0.02em] !leading-[1.2] !text-[var(--cpm-brand-navy)]">
                        Discard unsaved inline edits?
                    </h2>
                    <p className="m-0 !text-[13px] !font-semibold !leading-[1.5] !text-[var(--cpm-text-secondary)]">
                        You have {dirtyCount} uncommitted {dirtyCount === 1 ? 'change' : 'changes'}.
                        Leaving inline edit mode will throw them away.
                    </p>
                </div>
            </div>
            <CpmModalFooter>
                <div className="ml-auto flex items-center gap-[10px]">
                    <CpmButton variant="outlinePurple" size="modal" onClick={onKeep}>
                        Keep editing
                    </CpmButton>
                    <CpmButton variant="danger" size="modal" onClick={onDiscard}>
                        {discardLabel}
                    </CpmButton>
                </div>
            </CpmModalFooter>
        </CpmModal>
    );
}
